import Upload from './src/components/Upload';
Upload.install = (Vue)=>{
    Vue.components(Upload.name,Upload)
}
export default Upload;
